module.exports = __webpack_public_path__ + "img/campnconnect.41702ac9.webp";